<template>
  <div class="home">
    <leftpage class="homel" @listClick="listClickFn"></leftpage>
    <rightpage class="homer" :itemData="itemData" v-if="rightAndBottomShow"></rightpage>
    <bottomPage class="homeb" @xqData="xqDataFn" v-if="rightAndBottomShow"></bottomPage>
    <xqDialog v-if="dialogVisible==true" :itemData="itemData" @cancel="diaCancel"></xqDialog>
  </div>
</template>

<script>
  import {} from "@/api/api.js";

  import leftpage from './leftPage.vue';
  import rightpage from './rightPage.vue';
  import bottomPage from './bottomPage.vue';
  import xqDialog from './xqDialog.vue';
  export default {
    data() {
      return {
        rightAndBottomShow: false,
        dialogVisible: false,
        itemData: null,
      }
    },
    components: {
      leftpage,
      rightpage,
      bottomPage,
      xqDialog
    },
    mounted() {},
    watch: {},
    methods: {
      listClickFn(data) {
        this.$emit("changeStyle", {leftStyle: false,rightStyle: true });
        this.itemData = data;
        this.rightAndBottomShow = true;
      },
      xqDataFn(data) {
        this.dialogVisible = true;
      },
      diaCancel() {
        this.dialogVisible = false;
      },
    },
  }
</script>

<style scoped>
  @import url('../../common/css/all.css');
  .home {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .homel,
  .homer {
    position: absolute;
    width: 380px;
    z-index: 10;
    top: 80px;
    bottom: 10px;
    overflow: auto;
  }

  .homel {
    left: 10px;
  }

  .homer {
    right: 10px;
  }

  .homeb {
    position: absolute;
    width: 1120px;
    height: 150px;
    z-index: 10;
    bottom: 10px;
    left: 400px;
  }
</style>
